import {
  Component,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { DOCUMENT } from "@angular/common";
import * as $ from "jquery";
import { IUser } from "../../_models/common/user";
import { AuthenticationService } from "../../_services";
import { Router, NavigationEnd } from "@angular/router";
import { Claims } from "../../_models/common/claims";
import { ClaimsService } from "../../_services/common/claims.service";
import {
  IApiRequest,
  ApiRequest,
  FunctionPackageEnum,
  FMRoleType,
  FunctionPrivilege,
  UniversalImportTemplateEnum,
  IApiresponse,
  UserTypeEnum,
  CcImportTemplateTypeEnum,
} from "../../_models";
import { OrgSubscription } from "../../_models/common/OrgSubscription";
import { Guid } from "guid-typescript";
import { first, filter } from "rxjs/operators";
import { OrgSubscriptionPurchaseFunctionList } from "../../_models/billing-pricing/IOrgSubscriptionPurchaseFunctionList";
import { OrgSubscriptionFunctionList } from "../../_models/billing-pricing/OrgSubscriptionFunctionList";
import { RSAHelper } from "../../_helpers/RSAHelper";
import { OrganisationSettingService } from "../../_services/organisation-setting/organisation-setting.service";
import {
  DropdownItems,
  IGetCartDetailsRequest,
  GetCartDetailsRequest,
  ICartDetailsRequest,
  CartDetailsRequest,
  IPurchaseFunctionListRequest,
  PurchaseFunctionListRequest,
} from "../../_models/organisation-setting/organisation-setting";
import { parse } from "url";
import { Subscription } from "rxjs";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { FunctionPrivilegeService } from "../../_services/secondary-fm/function-privilege.service";
import { OrgBasicFunctionSubscriptionService } from "src/app/_services/billing-pricing/Org-BasicFunction-Subscription.service";
import { StorageData } from "src/app/_models/universal-importer/universal-importer";
import { AdvancesService } from "src/app/_services/advances/advance-service";
import { storeURLs, UTCDateTime } from "src/app/common/commonvariables";
import { DatePipe } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";
import { MarketingPopup } from "src/app/_models/common/marketing-popup";
import { ToastrService } from "ngx-toastr";
import { AlertPanelModel } from "src/app/_models/common/alertPanelModel";
import { AccountingIntegrationService } from "src/app/_services/Accounting/accounting-integration.service";
import { CreditCardService } from "src/app/_services/credit-card/credit-card.service";
import { CardReviewUploadedTransactionsRequest, CcImportModel, ICardReviewUploadedTransactionsRequest } from "src/app/_models/credit-card/credit-card";
import { UniversalImporterService } from "src/app/_services/universal-importer/universal-importer.service";
import { NotificationPanelService } from "src/app/_services/notification-panel.service";
import { NotificationService } from "src/app/_services/common/notification.service";
import { CommonModule } from "@angular/common";
import { RouterLink } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { CommonDropdownComponent } from "../../shared/common-dropdown/common-dropdown.component";
import { ImportCommonModuleModule } from "../../_modules/modules/import-common-module/import-common-module.module";
import { AlertModule } from "../../alert-panel/alert.module";
import { SharedModule } from "../../shared.module";
import { ICONS } from "../../_helpers/icons.constants";
import { TrialEndAlertPanelComponent } from "src/app/essential-pack/trial-end-alert-panel/trial-end-alert-panel.component";
import { PurchaseOrderPanelComponent } from "src/app/purchase-order/purchase-order-panel/purchase-order-panel.component";
@Component({
    selector: "app-nav-menu",
    templateUrl: "./nav-menu.component.html",
    standalone: true,
    imports: [SharedModule, RouterLink, FormsModule, TranslateModule, CommonDropdownComponent, ImportCommonModuleModule, CommonModule, AlertModule, TrialEndAlertPanelComponent, PurchaseOrderPanelComponent]
})
export class NavMenuComponent implements OnInit, OnDestroy {
  public ICONS = ICONS;
  IsSocialMediaUser: boolean = false;
  claimDropdownItems: Array<{ label: string; route: any; visible: boolean }> = [];
  approverDropdownItems: Array<{ label: string; route: any; visible: boolean }> = [];
  vendorDropdownItems: Array<{ label: string; route: any; visible: boolean }> = [];
  cardsDropdownItems: Array<{ label: string; route: any; visible: boolean }> = [];
  accountingExportDropdownItems: Array<{ label: string; route: any; visible: boolean }> = [];
  vendorShowAlertIcon: boolean = false;
  testNav: boolean = false;
  claims: Claims;
  isExpanded = false;
  logoutMenuVisible = false;
  currentUser: IUser;
  userDetails: any;
  users: IUser[] = [];
  imageSource: string = "assets/images/logo.png";
  twoStepApproval: boolean;
  isFinanceManager: boolean;
  routerLink: string;
  routerLinkSettings: string;
  routerLinkExp: string;
  routerLinkPay: string;
  routerLinkFA: string;
  routerLinkCards: string;
  routerLinkDashboard: string;
  menuChange: boolean;
  isCardSetupComplete: boolean = false;
  pendingAllForPayment: number = 0;
  CartCount: number = 0;

  ExportPackageId: string;

  OrgPurchaseFunctionRequest: IApiRequest<OrgSubscription>;
  OrgTrialingFunctionRequest: IApiRequest<OrgSubscription>;
  public UniqueId: Guid;
  PurchaseFunctionResponse: OrgSubscriptionPurchaseFunctionList;
  trialingFunctionResponse = <OrgSubscriptionFunctionList[]>[];
  isAccountingIntegrationPackagePurchasedOrTrial: boolean = false;
  Initials: string;
  FirstName: string;
  LastName: string;
  Email: string;
  OrgName: string;
  searchValue: number;
  searchItems = [];
  showSettingsMenu: boolean = false;
  activateAllFunctionsMenu: boolean = false;
  activateMySubscriptionMenu: boolean = false;
  activateComingSoonMenu: boolean = false;
  activatePricingMenu: boolean = false;
  isThirdLevelMenuVisible: boolean = false;
  activateSecondaryFMPrivilegeScreen: boolean = false;
  _routerSub = Subscription.EMPTY;
  private poSentSubscription: Subscription;
  isCreditCardPackageSubscribed: boolean = false;
  isPackagePurchasedOrTrial: boolean = false;
  public param: string;
  showLoginMarquee: boolean = false;
  marqueeText: string = "";
  isExportReportPackagePurchasedOrTrial: boolean = false;
  activateCreateNewReportMenu: boolean = false;

  showExportReportMarketingPopup: boolean;
  isPrimaryFM: boolean;
  myInvoicesVisible: boolean = false;
  isAdvancesAccess: boolean = false;
  isCarbonFootprintAccess: boolean = false;
  isFinanceApprovalAccess: boolean = false;
  isPayAccess: boolean = false;
  isCardAccess: boolean = false;
  isBuildReportAccess: boolean = false;
  isPrivilegeCheckStarted: boolean = false;
  isNRFCAccess: boolean = false;
  isPreApprovalAccess: boolean = false;
  storeURL = storeURLs;
  showQRCodePanel: boolean = false;
  isNotificationPanelActive: boolean = false;
  notificationsCount: number;
  isClaimOnWebAllowed: boolean = false;
  IsLeaveManagementAllowed: boolean;
  isUniversalImportAllowed: boolean;
  IsAPAutomationAllow: boolean;
  storageData: StorageData = new StorageData();
  userType: number = 0;
  kycStatus: number = 0;
  manageCCOptions: number = 0;
  showUnsubscribeNotificationPanel: boolean = false;
  isDarkMode: boolean;
  get universalImportTemplateEnum() {
    return UniversalImportTemplateEnum;
  }
  get userTypeEnum() {
    return UserTypeEnum;
  }
  activateImportStatementMenu: boolean = false;
  advanceBalanceOutstanding: boolean = false;
  isAdvanceBalanceChecked: boolean = false;
  isDelegator: boolean = false;
  isDelegate: boolean = false;
  isDelegateFunctionPurchasedOrTrial: boolean = false;
  isApAutomationAccess: boolean = false;
  isCarbonFootprintPurchasedOrTrial: boolean = false;
  @Output() toggleRightSidebarEvent = new EventEmitter<boolean>();

  @Output() mobileMenuButtonClicked = new EventEmitter<boolean>();

  isInFullscreenMode = false;
  isOrgBasicFunctionTrialEndsAlert: boolean = false;
  isPurchaseOrderPending: boolean = false;

  /**
   * The Purchase Order panel is hidden while on the activation route so that,
   * after returning from Stripe, only the activation panel is visible (not the PO panel).
   */
  get showPurchaseOrderPanel(): boolean {
    // When the trial-end alert is active it owns the purchase order panel, so don't double-render here.
    return this.isPurchaseOrderPending
      && !this.isOrgBasicFunctionTrialEndsAlert
      && !this.router.url.includes('purchase-order-activation');
  }
  isPayStepEnabled: boolean = false;
  bandId: number = 0;
  isRecallExportedExpensesPurchased: boolean = false;
  IsFaceIdRegistered = false;
  isContainerAllowed: boolean;
  showProfileMenu: boolean = false;
  isAccExportAccess: boolean = false;
  isRollbackExportedExpensesAccess: boolean = false;

  financeApprovalDropdownItems: Array<{ label: string; route: any; visible: boolean }> = [];
  payDropdownItems: Array<{ label: string; route: any; visible: boolean }> = [];

   isBasicFunctionPurchased: boolean = false;
  isSelfSetupOn: boolean = false;
  selfSetupPercentage: number = 0;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private authenticationService: AuthenticationService,
    private claimsService: ClaimsService,
    private router: Router,
    private organisationSettingService: OrganisationSettingService,
    private orgBasicFunctionSubscriptionService: OrgBasicFunctionSubscriptionService,
    private sanitizer: DomSanitizer,
    private functionPrivilegeService: FunctionPrivilegeService,
    public datepipe: DatePipe,
    private advancesService: AdvancesService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private accountingIntegrationService: AccountingIntegrationService,
    private creditCardService: CreditCardService,
    private universalImporterService: UniversalImporterService,
    private notificationPanelService: NotificationPanelService,
    private notificationService: NotificationService,
  ) {
    if (
      localStorage.getItem("claims") &&
      localStorage.getItem("claims") !== "undefined"
    ) {
      this.claimsService.updateClaims(
        JSON.parse(localStorage.getItem("claims"))
      );
    }

    this.claimsService.currentClaims.subscribe((claims) => {
      this.claims = claims;
      this.userType = this.claims.userType ? this.claims.userType : 0;
      this.kycStatus = this.claims.kycStatus;
      this.IsLeaveManagementAllowed = claims.IsLeaveManagementAllowed;
      this.isUniversalImportAllowed = claims.isUniversalImportAllowed;
      this.IsAPAutomationAllow = claims.IsAPAutomationAllow;
      this.isDelegator = this.claims.IsDelegator;
      this.isDelegate = this.claims.IsDelegate;
      this.isDelegateFunctionPurchasedOrTrial =
        this.claims.IsDelegateFunctionPurchasedOrTrial;
      this.isOrgBasicFunctionTrialEndsAlert =
        this.claims.IsOrgBasicFunctionTrialEndsAlert;
      this.isPurchaseOrderPending = this.claims.IsPurchaseOrderPending;
      this.isPayStepEnabled = this.claims.IsPayStepEnabled;
      this.bandId = this.claims.BandId;
      this.manageCCOptions = this.claims.ManageCCOptions;
      this.IsFaceIdRegistered = this.claims.IsFaceIdRegistered;
      this.isContainerAllowed = this.claims.IsContainerAllowed;
      this.isMFADeviceRegistered = this.claims.IsMFADeviceRegistered;
      this.isMFAEnabled = this.claims.IsMFAEnabled;
      this.showUnsubscribeNotificationPanel = this.claims.HasTemporaryUnsubscribed;
      this.isBasicFunctionPurchased = this.claims.isBasicFunctionPurchased;
      this.isSelfSetupOn = this.claims.IsSelfSetupOn;
      this.selfSetupPercentage = this.claims.SelfSetupPercentage;
    });

    if (localStorage.getItem("currentUser")) {
      this.userDetails = JSON.parse(localStorage.getItem("currentUser"));
      if (this.userDetails.RequestInfo) {
        this.FirstName = this.userDetails.RequestInfo.FirstName;
        this.LastName = this.userDetails.RequestInfo.LastName;
      } else if (this.userDetails.responseInfo) {
        this.FirstName = this.userDetails.responseInfo.firstName;
        this.LastName = this.userDetails.responseInfo.lastName;
      }
    } else if (localStorage.getItem("registereduser")) {
      this.userDetails = JSON.parse(localStorage.getItem("registereduser"));
      if (this.userDetails) {
        this.FirstName = this.userDetails.FirstName;
        this.LastName = this.userDetails.LastName;
      }
    }
    if (this.FirstName && this.FirstName != "") {
      this.Initials = this.FirstName.charAt(0);
    }
    if (this.LastName && this.LastName != "") {
      this.Initials += this.LastName.charAt(0);
    }
    this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.UniqueId = Guid.create();
    this.getOrgPurchaseFunctionList();
  }

  GetOrganisationPreferences() {
    let request = new ApiRequest<any>(
      "GetOrganisationPreferences",
      environment.applicationVersion,
      environment.requestId
    );
    this.organisationSettingService
      .GetOrganisationPreferences(request)
      .subscribe((data: IApiresponse<any>) => {
        if (data.statusCode == 0) {
          this.claims.RateType = data.responseInfo.rateType;
          this.claims.LocationLabel = data.responseInfo.locationLabel;
          this.claimsService.updateClaims(this.claims);
          this.claims.ManageCCOptions = data.responseInfo.manageCCOption;
          this.manageCCOptions = data.responseInfo.manageCCOption;
          this.claimsService.updateClaims(this.claims);
        }
      });
  }

  alertPanelModel = new AlertPanelModel(false, "", [], "", "", true, "");
  fnShowComplianceStatement() {
    if (localStorage.getItem("showComplianceStatement") == "1" && this.claims.showCompliancePopup && this.claims.IsFinanceManager) {
      this.claims.complianceStatement = this.claims.complianceStatement.split('<p>').join('<p class="d-block py-2 whitespace-pre">');
      this.alertPanelModel = new AlertPanelModel(true,
        this.claims.complianceHeader,
        [this.claims.complianceStatement], "",
        this.translate.instant("yes_i_agree"),
        false, "");
      this.alertPanelModel.bodyClass = "eod-panel-body-with-footer block";
      this.alertPanelModel.hideInfoIcon = true;
      this.alertPanelModel.singleMessagetextClass = "";
      localStorage.removeItem("showComplianceStatement");
    }
  }

  alertPanelReceiver(event) {
    this.alertPanelModel = new AlertPanelModel(
      false,
      "",
      [""],
      "",
      "",
      true,
      this.translate.instant("please_review_or_confirm")
    );
  }

  onSettingClick(value: boolean) {
    this.testNav = value;
  }

  onNotificationsCountChange(event) {
    this.notificationsCount = event;
  }

  openNotificationPanel() {
    this.notificationPanelService.openNotificationPanel();
  }
  closeNotificationPanel() {
    this.notificationPanelService.closeNotificationPanel();
  }
  basicFunctionRemainingTrialDays: number;
  getOrgBasicFunctionSubscriptionTrialDetails() {
    if (this.claims && this.claims.OrgId && this.isFinanceManager) {
      this.orgBasicFunctionSubscriptionService
        .GetOrgBasicFunctionSubscriptionTrialDetails(this.claims.OrgId)
        .subscribe((res: any) => {
          this.basicFunctionRemainingTrialDays =
            res.responseInfo.basicFunctionRemainingTrialDays;
        });
    }
  }
  linkClicked() {
    this.logoutMenuVisible = !this.logoutMenuVisible;
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  MouseOverEvent(e) {
    $(".profileActionMenu").addClass("active");
    $(".notify-icons a#profileAction").css("color", "#096094");
  }

  routeIsActive(routePath: string) {
    let currentUrl = this.router.url;
    return currentUrl.startsWith(routePath);
  }

  ngOnInit() {
    this.fnListenForPurchaseOrderSent();
    this.fnHandleSelfSetupNavigation(); //should be on top
    this.registerMFADevice();
    this.detectUrlUpdates();
    this.buildClaimDropdownItems();
    this.buildApproverDropdownItems();
    this.buildFinanceApprovalDropdownItems();
    this.buildPayDropdownItems();
    this.buildVendorDropdownItems();
    this.buildCardsDropdownItems();
    this.buildAccountingExportDropdownItems();
    this.claimsService.currentClaims.subscribe((claims) => {
      this.buildClaimDropdownItems();
      this.buildApproverDropdownItems();
      this.buildFinanceApprovalDropdownItems();
      this.buildPayDropdownItems();
      this.buildVendorDropdownItems();
      this.buildCardsDropdownItems();
      this.buildAccountingExportDropdownItems();
    });
    this.isFinanceManager = false;
    this.GetOrganisationPreferences();
 
    this.notificationPanelService.isNotificationPanelActive$.subscribe(isActive => {
      this.isNotificationPanelActive = isActive;
    });


    this.notificationPanelService.closeNotificationPanel$.subscribe(shouldClose => {
      if (shouldClose) {
        this.isNotificationPanelActive = false;
      }
    });

    this.claimsService.currentClaims.subscribe((claims) => {
      this.claims = claims;
      if (claims) {        
        this.IsSocialMediaUser = this.claims.IsSocialMediaUser;
        this.Email = this.claims.LoginId;
        this.OrgName = this.claims.OrgName;
        this.twoStepApproval = this.claims.TwoStepApproval;
        this.isFinanceManager = this.claims.IsFinanceManager;
        this.menuChange = this.claims.MenuSettings;
        this.isCardSetupComplete = this.claims.IsCardSetupComplete;
        this.pendingAllForPayment = this.claims.pendingAllForPayment;
        this.CartCount = this.claims.CartCount;
        this.isAccountingIntegrationPackagePurchasedOrTrial =
          this.claims.IsAccountingIntegrationPackagePurchasedOrTrial;
        this.isExportReportPackagePurchasedOrTrial =
          this.claims.IsExportReportPackagePurchasedOrTrial;
        this.isRecallExportedExpensesPurchased =
          this.claims.IsRecallExportedExpensesPurchased;
        this.isPrimaryFM = this.claims.FMRoleType === FMRoleType.AllPrivilege;
        this.isClaimOnWebAllowed = this.claims.isClaimOnWebAllowed;
        this.isOrgBasicFunctionTrialEndsAlert = this.claims.IsOrgBasicFunctionTrialEndsAlert;
        this.isPurchaseOrderPending = this.claims.IsPurchaseOrderPending;

        if (this.isPrimaryFM) {
          this.myInvoicesVisible = true;
          this.isFinanceApprovalAccess = true;
          this.isPayAccess = true;
          this.isCardAccess = true;
          this.isBuildReportAccess = true;
          this.isNRFCAccess = true;
          this.isAdvancesAccess = true;
          this.isPreApprovalAccess = true;
          this.isApAutomationAccess = true;
          this.isCarbonFootprintAccess = true;
          this.isAccExportAccess = true;
          this.isRollbackExportedExpensesAccess = true;
        } else if (this.claims.FMRoleType === FMRoleType.LimitedPrivilege) {
          if (!this.isPrivilegeCheckStarted) {
            this.isPrivilegeCheckStarted = true;
            var functionIds = [
              FunctionPrivilege.Invoices,
              FunctionPrivilege.FinanceApprover,
              FunctionPrivilege.PassforPayment,
              FunctionPrivilege.SetupCreditCard,
              FunctionPrivilege.TransferData,
              // FunctionPrivilege.NonReimbursableFuel,
              FunctionPrivilege.Advances,
              FunctionPrivilege.PreApprovals,
              FunctionPrivilege.CarbonFootprint,
              FunctionPrivilege.AccountingExport,
              FunctionPrivilege.RollbackExportedExpenses
            ];
            this.functionPrivilegeService
              .checkPrivilegesAccess(functionIds, this.claims.UserId)
              .subscribe((access) => {
                this.myInvoicesVisible =
                  access.indexOf(FunctionPrivilege.Invoices) > -1;
                this.isFinanceApprovalAccess =
                  access.indexOf(FunctionPrivilege.FinanceApprover) > -1;
                this.isPayAccess =
                  access.indexOf(FunctionPrivilege.PassforPayment) > -1;
                this.isCardAccess =
                  access.indexOf(FunctionPrivilege.SetupCreditCard) > -1;
                this.isBuildReportAccess =
                  access.indexOf(FunctionPrivilege.TransferData) > -1;
                this.isNRFCAccess = //need to clean up
                  access.indexOf(FunctionPrivilege.SetupAdvancedMileage) > -1;
                this.isAdvancesAccess =
                  access.indexOf(FunctionPrivilege.Advances) > -1;
                this.isPreApprovalAccess =
                  access.indexOf(FunctionPrivilege.PreApprovals) > -1;
                this.isApAutomationAccess =
                  access.indexOf(FunctionPrivilege.ApAutomation) > -1;
                this.isCarbonFootprintAccess = //not required
                  access.indexOf(FunctionPrivilege.CarbonFootprint) > -1;
                this.isAccExportAccess =
                  access.indexOf(FunctionPrivilege.AccountingExport) > -1;
                this.isRollbackExportedExpensesAccess =
                  access.indexOf(FunctionPrivilege.RollbackExportedExpenses) > -1;
              });
          }
        }

        if (this.Initials == undefined || this.Initials == "") {
          if (
            this.claims.FirstName != undefined &&
            this.claims.FirstName != ""
          ) {
            this.FirstName = this.claims.FirstName;
            this.Initials = this.claims.FirstName.charAt(0);
          }
          if (this.claims.LastName != undefined && this.claims.LastName != "") {
            this.LastName = this.claims.LastName;
            this.Initials += this.claims.LastName.charAt(0);
          }
        }
        this.isCreditCardPackageSubscribed =
          this.claims.IsCreditCardPackageSubscribed;
        this.isPackagePurchasedOrTrial = this.claims.IsPackagePurchasedOrTrial;
        if (this.claims.IsMarqueeOn == true) {
          this.showLoginMarquee = this.claims.IsMarqueeOn;
          this.marqueeText = this.claims.MarqueeText;
        }
        if (this.showLoginMarquee == true) {
          setTimeout(() => {
            this.showLoginMarquee = false;
            this.claims.IsMarqueeOn = false;
            this.claims.MarqueeText = "";
            this.claimsService.updateClaims(this.claims);
          }, 300000);
        }
        this.getAdvanceBalanceOutstanding();
      }
    });


    $(document).ready(function () {
      $(".profileActionMenu").mouseleave(function () {
        $(".profileActionMenu").removeClass("active");
        $(".notify-icons a#profileAction").css("color", "#686868");
      });

      $("#resNavMenu > li").click(function () {
        $("#resNavMenu li").removeClass("highlight-div");
        $(this).addClass("highlight-div");
        $("#resNavMenu li ul").slideUp();
        $(this).find("ul").slideToggle(400);
      });
    });
  }

        buildVendorDropdownItems() {
        this.vendorShowAlertIcon =
          (this.claims?.orgRoleId == 2 && this.claims.ReqForReviewCount > 0) ||
          (this.claims?.orgRoleId == 3 && (
            this.claims.ReqForReviewCount > 0 ||
            this.claims.ReqForFinanceReviewCount > 0 ||
            this.claims.ListOfDraftOrderCount > 0 ||
            this.claims.DraftPurchaseOrderCount > 0 ||
            this.claims.FinalPurchaseOrderCount > 0 ||
            this.claims.InvoiceForFinanceReviewCount > 0 ||
            this.claims.InvoiceForPayCount > 0 ||
            this.claims.UnallocatedInvoiceCount > 0 ||
            this.claims.PartiallyAllocatedInvoiceCount > 0 ||
            this.claims.FullyAllocatedInvoiceCount > 0
          ));
        this.vendorDropdownItems = [
        ];
      }

      onVendorDropdownItemSelected(item: any) {
        if (item && item.route) {
          this.router.navigate(item.route);
        }
      }

      buildCardsDropdownItems() {
        this.cardsDropdownItems = [
          {
            label: this.translate.instant('cc_dashboard_import_statement', this.param),
            route: ['/universalimport/ccuploadfile'],
            visible: this.isCreditCardPackageSubscribed
          }
        ].filter(item => item.visible);
      }

      onCardsDropdownItemSelected(item: any) {
        if (item && item.route) {
          this.navigatToImportCardStatement();
        }
      }

      buildAccountingExportDropdownItems() {
        this.accountingExportDropdownItems = [
          {
            label: this.translate.instant('export_report', this.param),
            route: ['/export/expenseexport'],
            visible: true
          },
          {
            label: this.translate.instant('label_log', this.param),
            route: ['/export/expenseexportlog'],
            visible: true
          },
          {
            label: this.translate.instant('accounting_integration', this.param),
            route: this.isAccountingIntegrationPackagePurchasedOrTrial ? ['/orgsetting/multiplecompanies'] : null,
            visible: this.isBuildReportAccess
          },
          {
            label: this.translate.instant('create_new_report', this.param),
            route: this.isExportReportPackagePurchasedOrTrial ? ['/export/reportwizard'] : null,
            visible: this.isBuildReportAccess
          },
          {
            label: this.translate.instant('existing_reports', this.param),
            route: ['/export/existingreports'],
            visible: this.isBuildReportAccess
          },
          {
            label: this.translate.instant('roll_back_exported_expenses', this.param),
            route: this.isRecallExportedExpensesPurchased ? ['/export/exportrollback'] : null,
            visible: this.isRollbackExportedExpensesAccess
          }
        ].filter(item => item.visible);
      }

      onAccountingExportDropdownItemSelected(item: any) {
        if (!item) return;
        if (item.label === this.translate.instant('accounting_integration', this.param) && !this.isAccountingIntegrationPackagePurchasedOrTrial) {
          this.fnNavigateToCart('false', 'export/accountingIntegrationList', 'Transfer Data to Sage/Tally/QB/Xero function', '29', '0');
        } else if (item.label === this.translate.instant('create_new_report', this.param) && !this.isExportReportPackagePurchasedOrTrial) {
          this.showCreateReportMarketingPopup();
        } else if (item.label === this.translate.instant('roll_back_exported_expenses', this.param) && !this.isRecallExportedExpensesPurchased) {
          this.showRecallExportedExpensesMarketingPopup();
        } else if (item.route) {
          this.router.navigate(item.route);
        }
      }

  buildClaimDropdownItems() {
          this.claimDropdownItems = [
            {
              label: this.userType == 0 ? this.translate.instant('expense', this.param) : '',
              route: this.isDelegateFunctionPurchasedOrTrial && this.isDelegate ? ['/claimant/delegatorsexpense'] : ['/claimant/expenselist'],
              visible: this.userType == 0
            },
            {
              label: this.translate.instant('delegate', this.param),
              route: ['/claimant/delegate'],
              visible: this.isDelegateFunctionPurchasedOrTrial && this.isDelegator && this.userType == 0
            },
            {
              label: this.translate.instant('cash_advance_title', this.param),
              route: ['/claimant/cashadvancelist'],
              visible: this.claims?.IsCashAdvanceEnabled && this.userType == 0
            },
            {
              label: this.translate.instant('cash_advance_on_credit_card_title', this.param),
              route: ['/claimant/ccadvancelist'],
              visible: this.claims?.IsCreditCardAdvanceEnabled && this.userType == 0
            },
            {
              label: this.translate.instant('non_reimbursable_fuel', this.param),
              route: ['/claimant/claimantnrlist'],
              visible: this.claims?.isNRPackagePurchasedOrTrial && this.claims?.nrfcStatus == 1 && this.userType == 0
            },
            {
              label: this.translate.instant('fuel_card', this.param),
              route: ['/claimant/claimantfclist'],
              visible: this.claims?.isFCPackagePurchasedOrTrial && this.claims?.nrfcStatus == 2 && this.userType == 0
            },
            {
              label: this.translate.instant('nr_dashboard', this.param),
              route: ['/claimant/claimantdashboard'],
              visible: this.claims?.isNRPackagePurchasedOrTrial && this.claims?.nrfcStatus == 1 && this.userType == 0
            },
            {
              label: this.translate.instant('fc_report', this.param),
              route: ['/orgsetting/claimantfcdashboard'],
              visible: this.claims?.isFCPackagePurchasedOrTrial && this.claims?.nrfcStatus == 2 && this.userType == 0
            },
            {
              label: this.translate.instant('vehicle_mangt_msg44', this.param),
              route: ['/claimant/mymileagerate'],
              visible: this.userType != this.userTypeEnum.Claimant
            }
          ].filter(item => item.visible);
        }
        onClaimDropdownItemSelected(item: any) {
          if (item && item.route) {
            this.router.navigate(item.route);
          }
        }
  buildApproverDropdownItems() {
    this.approverDropdownItems = [
      {
        label: this.translate.instant('expenses', this.param) + (this.claims?.pendingExpenseCountApprover > 0 ? ` (${this.claims.pendingExpenseCountApprover})` : ''),
        route: ['/approver/appclaimant', 1],
        visible: true
      },
      {
        label: this.translate.instant('non_reimbursable_fuel', this.param) + (this.claims?.pendingCountNRApprover > 0 ? ` (${this.claims.pendingCountNRApprover})` : ''),
        route: ['/approver/appnrreceipts'],
        visible: !!this.claims?.isNRPackagePurchasedOrTrial
      },
      {
        label: this.translate.instant('fuel_card', this.param) + (this.claims?.pendingCountFCApprover > 0 ? ` (${this.claims.pendingCountFCApprover})` : ''),
        route: ['/approver/appfcreceipts'],
        visible: !!this.claims?.isFCPackagePurchasedOrTrial
      },
      {
        label: this.translate.instant('pre_approval', this.param) + (this.claims?.pendingCountPreApproval > 0 ? ` (${this.claims.pendingCountPreApproval})` : ''),
        route: ['/approver/papproval'],
        visible: !!this.claims?.isPreApprovalPurchased && !!this.claims?.PreApprovalEnabled
      },
      {
        label: this.translate.instant('label_Advance', this.param) + (this.claims?.pendingAdvancesForApproval > 0 ? ` (${this.claims.pendingAdvancesForApproval})` : ''),
        route: ['/approver/advanceclaimantlist'],
        visible: !!this.claims?.isAdvancesFunctionPurchasedOrTrial
      }
    ].filter(item => item.visible);
  }

  onApproverDropdownItemSelected(item: any) {
    if (item && item.route) {
      this.router.navigate(item.route);
    }
  }

  buildFinanceApprovalDropdownItems() {
    this.financeApprovalDropdownItems = [
      {
        label: this.translate.instant('expenses', this.param) + (this.claims?.pendingForFinanceApproval > 0 ? ` (${this.claims.pendingForFinanceApproval})` : ''),
        route: ['/financeapprover/faexpenses', 1],
        visible: true
      },
      {
        label: this.translate.instant('non_reimbursable_fuel', this.param) + (this.claims?.pendingCountNRFinanceApproval > 0 ? ` (${this.claims.pendingCountNRFinanceApproval})` : ''),
        route: ['/financeapprover/nrreceipts'],
        visible: !!this.claims?.isNRPackagePurchasedOrTrial
      },
      {
        label: this.translate.instant('fuel_card', this.param) + (this.claims?.pendingCountFCFinanceApproval > 0 ? ` (${this.claims.pendingCountFCFinanceApproval})` : ''),
        route: ['/financeapprover/fcreceipts'],
        visible: !!this.claims?.isFCPackagePurchasedOrTrial
      },
      {
        label: this.translate.instant('label_Advance', this.param) + (this.claims?.pendingAdvanceForFinanceApproval > 0 ? ` (${this.claims.pendingAdvanceForFinanceApproval})` : ''),
        route: ['/financeapprover/advanceclaimantlist'],
        visible: !!this.claims?.isAdvancesFunctionPurchasedOrTrial
      }
    ].filter(item => item.visible);
  }

  onFinanceApprovalDropdownItemSelected(item: any) {
    if (item && item.route) {
      this.router.navigate(item.route);
    }
  }

  buildPayDropdownItems() {
    this.payDropdownItems = [
      {
        label: this.translate.instant('pay_expense', this.param) + (this.claims?.pendingExpensesForPayment > 0 ? ` (${this.claims.pendingExpensesForPayment})` : ''),
        route: ['/pay/payexpenses', 1],
        visible: true
      },
      {
        label: this.translate.instant('label_pay_Advance', this.param) + (this.claims?.pendingAdvancesForPayment > 0 ? ` (${this.claims.pendingAdvancesForPayment})` : ''),
        route: ['/pay/advanceclaimantlist'],
        visible: !!this.claims?.isAdvancesFunctionPurchasedOrTrial
      }
    ].filter(item => item.visible);
  }

  onPayDropdownItemSelected(item: any) {
    if (item && item.route) {
      this.router.navigate(item.route);
    }
  }

  
  getAdvanceBalanceOutstanding() {
    if (!this.isAdvanceBalanceChecked) {
      this.isAdvanceBalanceChecked = true;
      this.advancesService.isAdvanceBalanceOutstanding().subscribe((result) => {
        if (result && result.responseInfo) {
          this.advanceBalanceOutstanding = true;
        } else {
          this.advanceBalanceOutstanding = false;
        }
        this.claims.isAdvanceBalanceOutstanding =
          this.advanceBalanceOutstanding;
        this.claimsService.updateClaims(this.claims);
      });
    }
  }

  navSlider() {
    $(".overLayDiv").addClass("active");
    document.getElementById("mySidebar").style.width = "250px";
    document.getElementById("main").style.marginLeft = "0px";
  }

  closeNav() {
    $(".overLayDiv").removeClass("active");
    document.getElementById("mySidebar").style.width = "0";
    document.getElementById("main").style.marginLeft = "0";
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(["/login"]);
  }

  changePassword() {
    this.logoutMenuVisible = false;
    this.router.navigate(["changepassword"]);
  }

  billingPlan() {
    this.router.navigate(["billingplan"]);
  }

  fnNavigateToCart(
    is_Free,
    package_Path,
    function_PackageName,
    function_PackageId,
    function_Status
  ) {
    let isFree = is_Free.toString();
    let packagePath = package_Path.toString();
    let functionPackageName = function_PackageName.toString();
    let functionPackageId = function_PackageId.toString();
    let functionStatus = function_Status.toString();
    this.router.navigate(["/addtocart"], {
      queryParams: {
        isFree: this.EncryptParameters(isFree),
        packagePath: this.EncryptParameters(packagePath),
        functionPackageName: this.EncryptParameters(functionPackageName),
        functionPackageId: this.EncryptParameters(functionPackageId),
        functionStatus: this.EncryptParameters(functionStatus),
      },
    });
  }
  EncryptParameters(encryptValue) {
    let rsaHelper = new RSAHelper();
    let encrypt = rsaHelper.Encrypt(encryptValue);
    return encrypt;
  }
  getAvailableSearchFunctions() {
    this.organisationSettingService
      .GetOrganisationSettingList()
      .pipe(first())
      .subscribe(
        (data) => {
          if (data.statusCode == 0) {
            let result = data.responseInfo.functionCategoryDetail
              .filter((el) => {
                return el.functionPackageDetail.some((f) => {
                  return f.comingSoon == false;
                });
              })
              .map((a) => {
                a.functionPackageDetail = a.functionPackageDetail.filter(
                  (f) => f.comingSoon === false
                );
                return a;
              });
            let searchItemsList = [];
            result.forEach((a) => {
              a.functionPackageDetail.forEach((b) => {
                if (
                  b.functionPackageId == FunctionPackageEnum.LeaveManagement
                ) {
                  if (this.IsLeaveManagementAllowed) {
                    let searchItem = new DropdownItems();
                    searchItem.id = b.functionCategoryId;
                    searchItem.name = b.functionPackageName;
                    searchItemsList.push(searchItem);
                  }
                } else if (
                  b.functionPackageId == FunctionPackageEnum.UniversalImport
                ) {
                  if (this.isUniversalImportAllowed) {
                    let searchItem = new DropdownItems();
                    searchItem.id = b.functionCategoryId;
                    searchItem.name = b.functionPackageName;
                    searchItemsList.push(searchItem);
                  }
                } else if (
                  b.functionPackageId == FunctionPackageEnum.APAutomation
                ) {
                  if (this.IsAPAutomationAllow) {
                    let searchItem = new DropdownItems();
                    searchItem.id = b.functionCategoryId;
                    searchItem.name = b.functionPackageName;
                    searchItemsList.push(searchItem);
                  }
                }
                else if (
                  b.functionPackageId == FunctionPackageEnum.Container
                ) {
                  if (this.isContainerAllowed) {
                    let searchItem = new DropdownItems();
                    searchItem.id = b.functionCategoryId;
                    searchItem.name = b.functionPackageName;
                    searchItemsList.push(searchItem);
                  }
                } else {
                  let searchItem = new DropdownItems();
                  searchItem.id = b.functionCategoryId;
                  searchItem.name = b.functionPackageName;
                  searchItemsList.push(searchItem);
                }
              });
            });
            const uniq = new Set(searchItemsList.map((e) => JSON.stringify(e)));
            const res = Array.from(uniq).map((e) => JSON.parse(e));
            this.searchItems = res;
          }
        },
        (error) => {
          console.debug(error);
        }
      );
  }
  searchChanged(searchValue) {
    this.router.navigate(["settings"], { fragment: "place" + searchValue });
  }
  isSearchVisible(allFuncUrl) {
    let myUrl = parse(window.location.href);
    let currentUrl = myUrl.path;

    if (currentUrl == allFuncUrl) {
      return true;
    }
    this.searchValue = null;
    return false;
  }

  detectUrlUpdates() {
    this.setSettingsMenu("a");
    this._routerSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((value) => {
        this.setSettingsMenu(value);
      });
  }

  setSettingsMenu(urlDetails) {
    let myUrl = parse(window.location.href);
    let currentUrl = myUrl.path;
    let isRedirectFromMySubscriptionSettingPage = localStorage.getItem(
      "isRedirectFromMySubscriptionSettingPage"
    );

    if (
      currentUrl.startsWith("/dashboard") ||
      currentUrl.startsWith("/export") ||
      currentUrl.startsWith("/pay") ||
      currentUrl.startsWith("/financeapprover") ||
      currentUrl.startsWith("/card") ||
      currentUrl.startsWith("/claimant") ||
      currentUrl.startsWith("/ManageSubscription") ||
      currentUrl.startsWith("/shoppingcartlist") ||
      currentUrl.startsWith("/shoppingcartreview") ||
      currentUrl.startsWith("/stripeAgreement") ||
      currentUrl.startsWith("/shoppingcartConfirmed") ||
      currentUrl.startsWith("/referandearn") ||
      currentUrl.startsWith("/changepassword") ||
      currentUrl.startsWith("/support/support") ||
      currentUrl.startsWith("/support/unsubscribe") ||
      currentUrl.startsWith("/universalimport/ccuploadfile") ||
      currentUrl.startsWith("/universalimport/ccdefineheader") ||
      currentUrl.startsWith("/universalimport/ccimportheadermapping") ||
      currentUrl.startsWith("/universalimport/ccimportstmtreview") ||
      currentUrl.startsWith("/universalimport/ccimportsummary") ||
      currentUrl.startsWith("/approver")
    )
      this.showSettingsMenu = false;
    else this.showSettingsMenu = true;

    if (this.showSettingsMenu) {
      this.activateAllFunctionsMenu = currentUrl == "/settings";
      this.activateMySubscriptionMenu =
        currentUrl.startsWith("/settings");
      this.activateComingSoonMenu = currentUrl.startsWith("/comingsoon");
      this.activatePricingMenu = currentUrl.startsWith("/pricing");
      this.activateSecondaryFMPrivilegeScreen = currentUrl.startsWith(
        "/secondaryfm/privilege"
      );
      this.isThirdLevelMenuVisible =
        this.activateAllFunctionsMenu ||
        this.activateMySubscriptionMenu ||
        this.activateComingSoonMenu ||
        this.activateSecondaryFMPrivilegeScreen;

      if (
        this.showSettingsMenu &&
        !(
          this.activateAllFunctionsMenu ||
          this.activateMySubscriptionMenu ||
          this.activateComingSoonMenu ||
          this.activatePricingMenu
        )
      ) {
        if (
          isRedirectFromMySubscriptionSettingPage == "0" ||
          isRedirectFromMySubscriptionSettingPage == "1"
        ) {
          this.activateAllFunctionsMenu =
            isRedirectFromMySubscriptionSettingPage == "0";
          this.activateMySubscriptionMenu =
            isRedirectFromMySubscriptionSettingPage == "1";
        } else {
          this.activateAllFunctionsMenu = true;
          this.activateMySubscriptionMenu = false;
        }
      }
    } else {
      this.activateAllFunctionsMenu = false;
      this.activateMySubscriptionMenu = false;
      this.activateComingSoonMenu = false;
      this.activatePricingMenu = false;
      this.isThirdLevelMenuVisible = false;
    }

    if (
      currentUrl.startsWith("/export/reportwizard") ||
      currentUrl.startsWith("/export/createnewreport")
    ) {
      this.activateCreateNewReportMenu = true;
    } else {
      this.activateCreateNewReportMenu = false;
    }
  }

  routeUser() {
    if (this.claims.IsFinanceManager == true)
      this.router.navigate(["dashboard/overview"]);
    else this.router.navigate(["claimant/expenselist"]);
  }

  supportPage() {
    this.logoutMenuVisible = false;
    this.router.navigate(["support/support"]);
  }
  fnMyMileageRate() {
    this.logoutMenuVisible = false;
    this.router.navigate(["claimant/mymileagerate"]);
  }

  unsubscribe() {
    this.logoutMenuVisible = false;
    this.router.navigate(["support/unsubscribe"]);
  }


  paymentMethodActiveTab() {
    this.logoutMenuVisible = false;
    this.claims.invoiceActiveTab = "nav-paymentMethod";
    this.claimsService.updateClaims(this.claims);
    localStorage.setItem("BillingSettingsActiveTab", "nav-paymentMethod");
    this.router.navigate(["ManageSubscription"]);
  }

  assistedSupportActiveTab() {
    this.logoutMenuVisible = false;
    this.claims.invoiceActiveTab = "nav-implementationCharge";
    this.claimsService.updateClaims(this.claims);
    localStorage.setItem(
      "BillingSettingsActiveTab",
      "nav-implementationCharge"
    );
    this.router.navigate(["ManageSubscription"]);
  }
  yearlySupportActiveTab() {
    this.logoutMenuVisible = false;
    this.claims.invoiceActiveTab = "nav-yearlySupportCharge";
    this.claimsService.updateClaims(this.claims);
    localStorage.setItem(
      "BillingSettingsActiveTab",
      "nav-yearlySupportCharge"
    );
    this.router.navigate(["ManageSubscription"]);
  }
  fnManageSubscriptionClick() {
    this.logoutMenuVisible = false;
    this.claims.invoiceActiveTab = "nav-discountContract";
    this.claimsService.updateClaims(this.claims);
    localStorage.setItem("BillingSettingsActiveTab", "nav-discountContract");
    this.router.navigate(["ManageSubscription"]);
  }
  referAndEarnRoute() {
    this.logoutMenuVisible = false;
    this.router.navigate(["referandearn"]);
  }

  sanitizerHtml(element) {
    let svg = this.sanitizer.bypassSecurityTrustHtml(element);
    return svg;
  }

  fnCloseExportReportMarketingPopUp() {
    this.showExportReportMarketingPopup = false;
  }

  showCreateReportMarketingPopup() {
    this.getCartDetails();
    this.showExportReportMarketingPopup = true;
  }

  disableAddToCartForDataExport: boolean;
  getCartDetailsRequest: IApiRequest<IGetCartDetailsRequest>;
  disableAddToCart: boolean;
  cartList: any;
  getCartDetails(): any {
    this.getCartDetailsRequest = new ApiRequest<GetCartDetailsRequest>(
      "SoloGetCartDetails",
      1,
      "111"
    );
    this.getCartDetailsRequest.requestInfo = new GetCartDetailsRequest(
      this.claims.UserId,
      this.claims.OrgId
    );

    this.organisationSettingService
      .getCartDetailsList(this.getCartDetailsRequest)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data.responseInfo != null) {
            this.claims.CartCount = data.responseInfo.listCartDetails.length;
            this.claimsService.updateClaims(this.claims);
            this.cartList = data.responseInfo.listCartDetails;
            this.disableAddToCart = this.isFunctionInCart(
              FunctionPackageEnum.AccountingIntegration
            );
            this.disableAddToCartForDataExport = this.isFunctionInCart(
              FunctionPackageEnum.ExportReport
            );
          } else {
          }
        },
        (error) => { }
      );
  }

  isFunctionInCart(functionPackageId) {
    return this.cartList.some(
      (item) => item.functionPackageId == functionPackageId
    );
  }

  fnSaveCartDetailsForExportReport() {
    let request = new ApiRequest<ICartDetailsRequest>(
      "SaveCartDetails",
      environment.applicationVersion,
      environment.requestId
    );

    request.requestInfo = new CartDetailsRequest(
      0,
      0,
      false,
      FunctionPackageEnum.ExportReport,
      this.translate.instant("data_to_other_system")
    );
    this.organisationSettingService
      .SaveCartDetails(request)
      .pipe(first())
      .subscribe((data) => {
        if (data.statusCode == 0) {
          this.showExportReportMarketingPopup = false;
          this.routerNavigateToExportData();
        }
      });
  }

  routerNavigateToExportData() {
    let isFree = "false";
    let packagePath = "export/reportwizard";
    let functionPackageName = this.translate.instant("data_to_other_system");
    let functionPackageId = FunctionPackageEnum.ExportReport.toString();
    let functionStatus = "0";
    this.router.navigate(["/addtocart"], {
      queryParams: {
        isFree: this.EncryptParameters(isFree),
        packagePath: this.EncryptParameters(packagePath),
        functionPackageName: this.EncryptParameters(functionPackageName),
        functionPackageId: this.EncryptParameters(functionPackageId),
        functionStatus: this.EncryptParameters(functionStatus),
      },
    });
  }

  showZoomedDataExportImage: boolean;
  zoomDataExportImage() {
    this.showZoomedDataExportImage = true;
  }

  closeDataExportImage() {
    this.showZoomedDataExportImage = false;
  }

  closeQRCodePanel() {
    this.showQRCodePanel = false;
  }
  openQRCodePanel() {
    this.showQRCodePanel = true;
  }
  navegateToGrid(page, url) {
    this.router.navigate([url], {
      queryParams: {
        page: this.EncryptParameters(page),
      },
    });
  }

  navigatToImportCardStatement() {
    localStorage.setItem("isCameFromCreditCardImport" + this.claims.OrgId, "1");
    this.storageData.importTemplate =
      UniversalImportTemplateEnum.ImportCreditCardStatement;
    this.router.navigate(["/universalimport/ccuploadfile"]);
  }

  isCardMenuActive() {
    this.activateImportStatementMenu =
      this.routeIsActive("/universalimport/ccuploadfile") ||
      this.routeIsActive("/universalimport/ccdefineheader") ||
      this.routeIsActive("/universalimport/ccimportheadermapping") ||
      this.routeIsActive("/universalimport/ccimportstmtreview") ||
      this.routeIsActive("/universalimport/ccimportsummary");

    if (
      this.routeIsActive("/card") ||
      this.routeIsActive("/universalimport/ccuploadfile") ||
      this.routeIsActive("/universalimport/ccdefineheader") ||
      this.routeIsActive("/universalimport/ccimportheadermapping") ||
      this.routeIsActive("/universalimport/ccimportstmtreview") ||
      this.routeIsActive("/universalimport/ccimportsummary")
    ) {
      return true;
    } else {
      return false;
    }
  }

  getOrgPurchaseFunctionList() {
    let request = new ApiRequest<IPurchaseFunctionListRequest>(
      "SoloPurchaseFunctionList",
      environment.applicationVersion,
      environment.requestId
    );
    request.requestInfo = new PurchaseFunctionListRequest(
      this.claims.UserId,
      this.claims.OrgId
    );
    this.organisationSettingService
      .soloPurchaseFunctionList(request)
      .subscribe((data: IApiresponse<any>) => {
        if (data.statusCode == 0) {
          if (data.responseInfo.orgPaidFunctionList.length > 0) {
            let purchaseFuncListDetails =
              data.responseInfo.orgPaidFunctionList[0].paidFunctions;
            var preApprov = purchaseFuncListDetails.find(
              (x) => x.functionId == FunctionPackageEnum.Pre_Approvals
            );
            if (preApprov) {
              this.claims.isPreApprovalPurchased = true;
            }
            var nrPurchased = purchaseFuncListDetails.find(
              (x) => x.functionId == FunctionPackageEnum.NonReimbursableFuel
            );
            if (nrPurchased) {
              this.claims.isNRPackagePurchasedOrTrial = true;
            }
            var fcPurchased = purchaseFuncListDetails.find(
              (x) => x.functionId == FunctionPackageEnum.FuelCard
            );
            if (fcPurchased) {
              this.claims.isFCPackagePurchasedOrTrial = true;
            }
            var advancesPurchased = purchaseFuncListDetails.find(
              (x) => x.functionId == FunctionPackageEnum.Advances
            );
            if (advancesPurchased) {
              this.claims.isAdvancesFunctionPurchasedOrTrial = true;
            }
            var apAutomationPurchased = purchaseFuncListDetails.find(
              (x) => x.functionId == FunctionPackageEnum.APAutomation
            );
            if (apAutomationPurchased) {
              this.claims.isAPAutomationFunctionPurchasedOrTrial = true;
            }

            var carbonFoorprintPurchased = purchaseFuncListDetails.find(
              (x) => x.functionId == FunctionPackageEnum.CarbonFootprint
            );

            if (carbonFoorprintPurchased) {
              this.isCarbonFootprintPurchasedOrTrial = true;
            }

            this.claimsService.updateClaims(this.claims);
          }
        }
      });
  }
  fnGetClass() {
    if (this.isFinanceManager) {
      return "col-md-8";
    } else {
      return "col-md-12";
    }
  }

  toggleRightSidebar() {
    this.toggleRightSidebarEvent.emit(true);
  }

  element: any;
  fullscreen() {
    this.element = document.documentElement;
    document.body.classList.toggle("fullscreen-enable");
    if (
      !document.fullscreenElement &&
      !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement
    ) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }

      this.isInFullscreenMode = true;
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }

      this.isInFullscreenMode = false;
    }
  }

  toggleMobileMenu(event) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Real-time: when sales submits the PO while the prospect is exploring the app, open the
   * purchase order panel immediately (the trial-end alert panel owns this when the trial has ended).
   */
  private fnListenForPurchaseOrderSent(): void {
    this.poSentSubscription = this.notificationService
      .onNotificationRaised()
      .subscribe((notification: any) => {
        if (notification?.text?.key === 'po_sent') {
          if (this.claims) {
            this.claims.IsPurchaseOrderPending = true;
            this.claimsService.updateClaims(this.claims);
          }
          this.isPurchaseOrderPending = true;
        }
      });
  }

  ngOnDestroy() {
    this.poSentSubscription?.unsubscribe();
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      /* Firefox */
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      /* Chrome, Safari and Opera */
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      /* IE/Edge */
      this.document.msExitFullscreen();
    }
  }
  basicFunctionTrialDays: number;
  basicFuncEndDate: any;
  isDisplayEssDetail: boolean;
  fnRedirectToEssPack() {
    this.isDisplayEssDetail = false;
    localStorage.setItem("isEssentialPackSubscribeDisplay", "1");
    this.router.navigate(["/essential-pack"]);
  }

  recallExportedExpensesMarketingPopupModel: any;
  recallExportedExpensesMarketingPopup = false;

  showRecallExportedExpensesMarketingPopup() {
    if (this.claims.IsRecallExportedExpensesPurchased) {
      this.recallExportedExpensesMarketingPopup == false;
      this.router.navigate(["export/exportrollback"]);
    } else {
      this.recallExportedExpensesMarketingPopup = true;
      this.recallExportedExpensesMarketingPopupModel = new MarketingPopup(
        this.translate.instant("roll_back_exported_expenses"),
        this.translate.instant("Roll Back Any Expense You Want"),
        "",
        null,
        "../../assets/svg-icons/build-report-image.svg",
        "../../assets/images/roll_back_exported_expense.png",
        "",
        FunctionPackageEnum.RecallExportedExpenses,
        this.translate.instant("Recall Exported Expenses"),
        "export/exportrollback",
        0,
        0,
        "",
        [
          this.translate.instant(
            "Humans are Prone to Errors, so are you. But the good thing about this function is that it lets you correct those."
          ),
        ],
        this.translate.instant(
          "Humans are Prone to Errors, so are you. But the good thing about this function is that it lets you correct those."
        )
      );
    }
  }

  closeMarketingPopup() {
    this.recallExportedExpensesMarketingPopup = false;
  }


  isMFAEnabled: boolean = false;
  showMFAPanel = false;

  qrCodeUrl: string = '';
  qrSecret: string = '';
  qrToken: string = '';
  verifyToken(): void {

    let request = new ApiRequest<any>(
      "verifyTotp",
      environment.applicationVersion,
      environment.requestId
    );

    request.requestInfo =
    {
      token: this.qrToken,
      secret: this.qrSecret,
      emailId: this.claims.LoginId
    }

    this.authenticationService.verifyTotp(request).subscribe(response => {
      if (response.verified) {
        this.toastr.success('Success');
        this.claims.IsMFADeviceRegistered = true;
        this.isMFADeviceRegistered = true;
        this.claimsService.updateClaims(this.claims);
      } else {
        this.toastr.error('Invalid token');
      }
    });
  }

  registerMFADevice() {

    let request = new ApiRequest<any>(
      "verifyTotp",
      environment.applicationVersion,
      environment.requestId
    );

    request.requestInfo =
    {
      emailId: this.claims.LoginId
    }


    this.authenticationService
      .getTotpSetup(request)
      .subscribe((data) => {
        this.qrCodeUrl = data.responseInfo.qrCodeUrl;
        this.qrSecret = data.responseInfo.secret;
      });
  }

  isMFADeviceRegistered: boolean = false;

  registerNewMFADevice() {

    this.isMFADeviceRegistered = false;

  }

  onTokenChange(value) {
    this.qrToken = value;
  }

  reviewImportsResponse: any = {};
  cardOrganisationList = [];

  importStatementNow() {
    this.accountingIntegrationService
      .GetXeroBankTransactionsToImportCompanyId(this.claims.OrgId)
      .subscribe((res: IApiresponse<any>) => {
        if (res.statusCode == 0 && res.responseInfo && res.responseInfo.length > 0) {



          this.creditCardService.GetCardOrganisation(this.claims.OrgId)
            .subscribe(cOrgResponse => {
              if (cOrgResponse.statusCode == 0 && cOrgResponse.responseInfo) {
                this.cardOrganisationList = cOrgResponse.responseInfo;
                let activeCardList = this.cardOrganisationList.filter(it => it.isActive && it.cardOrganisationId > 0);
                this.creditCardService
                  .GetCardImportTemplateDetail(this.claims.OrgId, activeCardList[0].cardOrganisationId)
                  .subscribe((response) => {
                    if (response.statusCode == 0 && response.responseInfo) {
                      let ccImportModel = new CcImportModel();
                      let ccTemplate = response.responseInfo;
                      if (ccTemplate.importTemplateType) {
                        ccImportModel.isTemplateModified = false;
                      } else {
                        ccTemplate.importTemplateType =
                          CcImportTemplateTypeEnum.MultipleUser;
                        ccImportModel.isTemplateModified = true;
                      }
                      ccTemplate.expenseDateCol = 1;
                      ccTemplate.cardNumberCol = 2;
                      ccTemplate.amountCol = 3;
                      ccTemplate.currencyCol = 4;
                      ccTemplate.exchangeRateCol = 5;
                      ccTemplate.localCurrencyAmountCol = 6;
                      ccTemplate.supplierCol = 7;
                      ccTemplate.notes1Col = 9;
                      ccTemplate.notes2Col = 10;
                      ccTemplate.referenceNumberCol = 13;
                      ccImportModel.templateDetails = ccTemplate;
                      this.storageData.cardImportTemplateHeaderConfiguration = {
                        ...ccImportModel,
                      };
                      this.storageData.cardImportTemplateHeaderConfiguration.statementDate =
                        new Date();
                      this.storageData.cardImportTemplateHeaderConfiguration.cardOrganisationId = 90;
                      this.universalImporterService.fnSaveDataToLocalStorage(
                        this.storageData
                      );
                      this.storageData.importTemplatFileName = "Card Transactions";
                      this.storageData.importedTemplateData = res.responseInfo;
                      this.storageData.templateData = res.responseInfo;
                      this.storageData.gridData = res.responseInfo;
                      this.storageData.gridData = this.storageData.gridData.map(
                        (element, index) => {
                          element.uniqueRowId = index + 1;
                          return element;
                        }
                      );

                      this.storageData.importTemplateExtension = "csv";
                      this.storageData.importStep = 3;
                      localStorage.setItem("isCreditCardImportFromXero", "1");
                      localStorage.setItem(
                        "isCameFromCreditCardImport" + this.claims.OrgId,
                        "1"
                      );
                      this.storageData.importTemplate =
                        UniversalImportTemplateEnum.ImportCreditCardStatement;
                      this.universalImporterService.fnSaveDataToLocalStorage(
                        this.storageData
                      );

                      var reviewUploadedCardStatementRequestData =
                        new CardReviewUploadedTransactionsRequest(
                          this.claims.OrgId,
                          this.storageData.cardImportTemplateHeaderConfiguration?.templateDetails,
                          this.storageData.gridData
                        );
                      let reviewUploadedCardStatementRequest =
                        new ApiRequest<ICardReviewUploadedTransactionsRequest>(
                          "ReviewUploadedCardStatement",
                          1.0,
                          "111"
                        );

                      reviewUploadedCardStatementRequest.requestInfo =
                        reviewUploadedCardStatementRequestData;

                      this.creditCardService
                        .ReviewUploadedCardStatementNew(
                          reviewUploadedCardStatementRequest
                        )
                        .subscribe((response: any) => {
                          this.reviewImportsResponse = response.responseInfo;

                          for (
                            let index = 0;
                            index <
                            this.reviewImportsResponse.processedImportDataList.length;
                            index++
                          ) {
                            this.reviewImportsResponse.processedImportDataList[
                              index
                            ].amount =
                              this.reviewImportsResponse.processedImportDataList[
                                index
                              ].localCurrencyAmount;
                          }

                          this.reviewImportsResponse.statementDate = new Date(
                            UTCDateTime.getUTCDate(
                              new Date(
                                this.storageData?.cardImportTemplateHeaderConfiguration?.statementDate
                              )
                            )
                          ).toISOString();
                          this.reviewImportsResponse.organisationId = this.claims.OrgId;
                          this.reviewImportsResponse.importedBy = -1; // this.claims.UserId;
                          this.reviewImportsResponse.fmName =
                            this.claims.FinanceManager;
                          this.reviewImportsResponse.cardOrganisationId =
                            this.storageData.cardImportTemplateHeaderConfiguration.cardOrganisationId;
                          let saveReviewedImportsRequest = new ApiRequest<object>(
                            "SoloSaveReviewedImports",
                            1.0,
                            "111"
                          );

                          saveReviewedImportsRequest.requestInfo =
                            this.reviewImportsResponse;

                          this.creditCardService
                            .BulkCreditCardExpensesImport(saveReviewedImportsRequest)
                            .subscribe((jobId) => {
                              if (jobId) {
                                localStorage.removeItem("isCreditCardImportFromXero");
                              }
                            });
                        });
                    }
                  });

              }
            });
        }
      });
  }

  fnHandleSelfSetupNavigation() {
    if(this.claims.IsFinanceManager && this.claims.isBasicFunctionPurchased && this.claims.IsSelfSetupOn && this.claims.SelfSetupPercentage != 100){
        let myUrl = parse(window.location.href);
        let currentRoute = myUrl.path;

        let allowedRoutes = [
        '/orgsetting/manageemployee',
        '/taxSetup',
        '/orgsetting/categorySetup',
        '/orgsetting/mileagewizard',
        '/orgsetting/dailyCappingLimit',
        '/export/reportwizard',
        '/settings',
        '/self-setup'
      ];

        const isSetupRoute = allowedRoutes.some(route =>
          currentRoute.startsWith(route)
        );

        if (!isSetupRoute) {
          this.router.navigate(['/self-setup']);
        }
    }  
  }

}